
export default {

    "e-mail" : "e-mail",
    "password" : "parolă",
    "wrong_email_password" : "e-mail sau parolă incorectă",
    "login" : "Autentificare"

};
